import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import {
  useDietPlanList,
  useDraftHeaderList,
  useHomePageTagLineList,
  useReorderKitList,
  useReviewList,
  useRootCauseList,
  useRootCauseSectionList,
  useTaskList,
  useTrayaDoctorList,
  useWelcomeVideoList,
  userCoachTipList,
} from "./store";
import { isEmpty } from "lodash";
import EditableCard from "./EditableCard";

function MasterTable() {
  const { fetchTaskList, taskListData } = useTaskList();
  const { coachTipListData, fetchCoachTipList } = userCoachTipList();
  const { dietPlanListData, fetchDietPlanList } = useDietPlanList();
  const { homePageTagLineListData, fetchHomePageTagLineList } =
    useHomePageTagLineList();
  const { reorderKitListData, fetchReorderKitListData } = useReorderKitList();
  const { rootCauseListData, fetchRootCauseListData } = useRootCauseList();
  const { rootCauseSectionListData, fetchRootCauseSectionListData } =
    useRootCauseSectionList();
  const { trayaDoctorListData, fetchTrayaDoctorListData } =
    useTrayaDoctorList();
  const { draftHeaderListData, fetchDraftHeaderListData } =
    useDraftHeaderList();
  const { reviewListData, fetchReviewListData } = useReviewList();
  const { welcomeVideoListData, fetchWelcomeVideoListData } =
    useWelcomeVideoList();

  // Define a state variable to keep track of the active tab
  const [activeTab, setActiveTab] = useState("task-list");

  // Function to handle tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
    // Perform API call based on the selected tab
    switch (key) {
      case "task-list":
        fetchTaskList();
        break;
      case "coach-tip-list":
        fetchCoachTipList();
        break;
      case "diet-plan-list":
        fetchDietPlanList();
        break;
      case "home-page-tag-line-list":
        fetchHomePageTagLineList();
        break;
      case "reorder-kit-list":
        fetchReorderKitListData();
        break;
      case "root-cause-list":
        fetchRootCauseListData();
        break;
      case "root-cause-section-list":
        fetchRootCauseSectionListData();
        break;
      case "doctor-list":
        fetchTrayaDoctorListData();
        break;
      case "draft-header-data-list":
        fetchDraftHeaderListData();
        break;
      case "user-review-list":
        fetchReviewListData();
        break;
      case "welcome-video-list":
        fetchWelcomeVideoListData();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // Fetch initial data for the default tab (task-list)
    fetchTaskList();
  }, []);

  return (
    <>
      <div>
        <h1>Master Table</h1>
      </div>
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="uncontrolled-tab-example"
      >
        <Tab
          eventKey="task-list"
          title="Task List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(taskListData) && (
            <EditableCard
              data={taskListData.listOfTask}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="coach-tip-list"
          title="Coach Tip List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(coachTipListData) && (
            <EditableCard
              data={coachTipListData.listOfCoachTips}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="diet-plan-list"
          title="Diet Plan List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(dietPlanListData) && (
            <EditableCard
              data={dietPlanListData.listOfDietPlan}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="home-page-tag-line-list"
          title="Home Page Tag Line List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(homePageTagLineListData) && (
            <EditableCard
              data={homePageTagLineListData.listOfHomePageTagLineList}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="reorder-kit-list"
          title="Reorder Kit List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(reorderKitListData) && (
            <EditableCard
              data={reorderKitListData.listOfReorderKitList}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="root-cause-list"
          title="Root Cause List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(rootCauseListData) && (
            <EditableCard
              data={rootCauseListData.listOfRootCause}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="root-cause-section-list"
          title="Root Cause Section List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(rootCauseSectionListData) && (
            <EditableCard
              data={rootCauseSectionListData.listOfUserRootCauseSection}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="doctor-list"
          title="Traya Doctor List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(trayaDoctorListData) && (
            <EditableCard
              data={trayaDoctorListData.listOfTrayaDoctor}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="draft-header-data-list"
          title="Draft Header Data List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(draftHeaderListData) && (
            <EditableCard
              data={draftHeaderListData.listOfUserDraftHeaderData}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="user-review-list"
          title="User Review List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(reviewListData) && (
            <EditableCard
              data={reviewListData.listOfUserReviews}
              activeKey={activeTab}
            />
          )}
        </Tab>
        <Tab
          eventKey="welcome-video-list"
          title="Welcome Video List"
          className="border-bottom border-x p-3"
        >
          {!isEmpty(welcomeVideoListData) && (
            <EditableCard
              data={welcomeVideoListData.listOfWelcomeVideos}
              activeKey={activeTab}
            />
          )}
        </Tab>
      </Tabs>
    </>
  );
}

export default MasterTable;